module.exports = __webpack_public_path__ + "static/media/delete-message.fdc645ef.svg";